import React from "react";
import ProductDetail from ".";
import { MODEL_KEY } from "config/products";

function Iphone18Pro() {
  return <ProductDetail modelId={MODEL_KEY.IPHONE18PRO} />;
}

export default Iphone18Pro;
